import { MessageDescriptor } from 'react-intl'

export const OneOrMoreItemsSelected: MessageDescriptor = {
  id: 'filters.OneOrMoreItemsSelected',
  defaultMessage: 'Selected',
  description:
    'The text shown in the filter component when one or more but not all are selected'
}

export const NoItemsSelected: MessageDescriptor = {
  id: 'filters.NoItemsSelected',
  defaultMessage: '-Select-',
  description:
    'The text shown in the filter component when no items are selected'
}

export const AllItemsSelected: MessageDescriptor = {
  id: 'filters.AllItemsSelected',
  defaultMessage: 'All',
  description:
    'The text shown in the filter component when ALL items are selected'
}

export const SelectAll: MessageDescriptor = {
  id: 'filters.SelectAll',
  defaultMessage: 'Select all',
  description:
    'The text shown in the filter which controls the select/deselect all items'
}

export const ApplyFilters: MessageDescriptor = {
  id: 'filters.button.ApplyFilters',
  defaultMessage: 'Apply filters',
  description: 'The text shown in the button at the bottom of the filter list'
}

export const NoFilters: MessageDescriptor = {
  id: 'filters.button.NoFilters',
  defaultMessage: 'No filters found',
  description:
    'The text shown in filter list when no filters are found by the search criteria'
}
